import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_dbl",
  "use": "icon-arrow_dbl-usage",
  "viewBox": "0 0 11 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 11 12\" id=\"icon-arrow_dbl\">\n<path fill-rule=\"evenodd\" d=\"M5.499,0.000 L10.999,4.999 L0.000,4.999 L5.499,0.000 ZM5.499,11.999 L0.000,7.000 L10.999,7.000 L5.499,11.999 Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol